import React, {useState, useEffect} from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {normalizeInput, normalizeDate, calculate_age, isvalid_mdy,normalizeUSDate} from './functions';
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import {updateGolferProfile, updateGolfer} from '../API/APICalls';


export default function PersonalInfoForm ({stripe}:any) {
    const navigate = useNavigate();
   
    const location = useLocation();

    const zipsearch = location.state.zipcode;
    const agadata = location.state.aga;
    const golferdata = location.state.inputs;
    //console.log(golferdata);
   
    const [inputs, setInputs] = useState({firstname: golferdata.firstname || '', lastname: golferdata.lastname, phone: normalizeInput(golferdata.phone) || '', email: golferdata.email, dob: normalizeUSDate(golferdata.dob) || golferdata.date_of_birth ||'', sex: golferdata.sex|| golferdata.gender || '', address: golferdata.address || '', address2:  golferdata.address2 || golferdata.street_address_2 || '', city: golferdata.city || '', state:agadata[0].state, zip: agadata[0].zipcode ||'', contact: golferdata.contact_guid || golferdata.contact || '', handicapID: golferdata.handicapID || ''});
   
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) => setInputs(inputs => ({ ...inputs, [name]: value }));

    const [validate, setValidate] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);

       

        //make call to API for create or update golfer
        const golfer = golferdata;
        
        const response= await updateGolferProfile(agadata, inputs, location.pathname);
        
       
        if (!JSON.parse(response || '')?.result)
        {
            if (inputs.contact == "")
            {
              inputs.contact = JSON.parse(response || '').properties.contact_guid;
            } 
            
            navigate('/address', {replace:true, state:{zipcode:zipsearch, aga:agadata, inputs:inputs}}); 
        } else {
          //wait for a few more seconds and try so we save the data because hubspot needs time to add the records etc.
          setTimeout(() => {
            handleSubmit(event);
            }, 5000);

        }   
      }

      
      const formatDob = (event:React.KeyboardEvent<HTMLInputElement>) => { 
          
        let check_formatted = false;

        const result = normalizeDate(event.currentTarget.value)
        
        if (result!= "")
        {
          check_formatted = isvalid_mdy(result);
        } else {
          check_formatted = false;
        }
        
          
       const age = calculate_age(result);
       
       setInputs({... inputs, "dob": result });


       if (isNaN(age) && age >= 13 && age <=100 && check_formatted && result.length >= 10)
       {
        setValidate(true);
       }
       
       if (age >= 13 && age <=100 && check_formatted && result.length >= 10 ) 
       {
          setValidate(false);
       } else if (!age && age > 0)
       {
        setValidate(false);
       } else if (age && age == 0) {
       } else {
          setValidate(true);
       }
               
    }

    const formatPhoneNumberPasted = (event:React.ClipboardEvent<HTMLInputElement>) => {     
      event.preventDefault();
    }


      const formatPhoneNumber = (event:React.KeyboardEvent<HTMLInputElement>) => { 
              const result = normalizeInput(event.currentTarget.value || '')
              setInputs({... inputs, "phone": result });
      }

      const handleBlur = (event:React.ChangeEvent<HTMLInputElement>) => { 
        console.log("now checking email")
      }

      useEffect(() => {
        //navigate(".", { replace: true, state: { zipcode:zipsearch, aga:agadata, inputs:golferdata } })
         setIsLoading(false);
          //setInputs(golferdata);
         //console.log(golferdata) ;

     }, [location.pathname]);


    return (
        <div className="container page_container mb-5 pb-1">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"><h1 className="fs-1 text-left">Personal Information</h1></div>
            
            <div className="col-12">
            <form onSubmit={handleSubmit} name="Personal Information" autoComplete="off" > 
            
            {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
            </div>
            : ''}
            
            <div className="col-sm-12 col-12 col-md-12 col-lg-12" >
                
                <div className="row">
                  <div className="col-sm-6 pt-0 pb-2">
                    <label className="form-label">First Name*</label>
                    <input type="text" className="form-control" id="firstName" name="firstname" value={inputs.firstname || ''} onChange={handleChange} pattern="^[a-zA-Z\/'\-\w+ ?]+|[^@$^%*&#!]+^[^\x20-\x7F]$" required={true} onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Please enter valid First Name.')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}/>
                    <div className="invalid-feedback">
                      Valid first name is required.
                    </div>
                  </div>

                  <div className="col-sm-6 pt-0 pb-2">
                    <label className="form-label">Last Name*</label>
                    <input type="text" className="form-control" id="lastname" name="lastname" value={inputs.lastname} onChange={handleChange} pattern="^[a-zA-Z\/'\-\w+ ?]+|[^@$^%*&#!]+^[^\x20-\x7F]$" required={true} onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Please enter valid Last Name.')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}/>
                    <div className="invalid-feedback">
                      Valid last name is required.
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 mt-1">
                      <label className="form-label">Phone Number*</label>
                      <input type="text" pattern="[0-9\(\)\-\s]{14,14}" placeholder="(999) 999-9999" autoComplete="off" className="form-control" id="phone" name="phone" value={inputs.phone ||''} onChange={handleChange} onKeyUp={formatPhoneNumber} onPaste={formatPhoneNumberPasted} minLength={14} maxLength={14}  required={true}/>
                      
                  </div>

                  <div className="col-sm-12 mt-2">
                      <label className="form-label">Email*</label>
                      <input type="email" className="form-control" id="email" name="email" placeholder="" value={inputs.email} onChange={handleChange} onBlur={handleBlur} disabled/>
                      
                  </div>

                  <div className="col-12 col-sm-12 mt-1">
                      <div className="row">
                        <div className="col-6 col-sm-5 mt-4">
                          <label className="form-label">Date of Birth* <i className="bi bi-info-circle" data-tooltip-id="dob-tooltip"></i></label>
                          <input type="text" className="form-control" id="dob" placeholder="MM/DD/YYYY" name="dob" value={inputs.dob} onChange={handleChange} onKeyUp={formatDob} minLength={6} maxLength={10} required={true}/>
                            <ReactTooltip
                              id="dob-tooltip"
                              place="top"
                              content="You must be at least 13 years old to join."
                            />
                            {validate ? 
                              <div className="fs-6 pt-2 text-danger ">
                               You must be at least 13 years old to join.
                              </div>
                              : ''}
                        </div>
                        <div className="col-6 col-sm-7 mt-4">
                          
                          <label className="form-label">Sex* <i className="bi bi-info-circle" data-tooltip-id="sex-tooltip"></i></label>
                          <ReactTooltip
                              id="sex-tooltip"
                              place="top"
                              content="Sex is used for applying proper Ratings for score posting."
                            />
                          <div className="col-12 col-sm-12">
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" id="male" name="sex" value='M' onChange={handleChange} checked={inputs.sex === "M"} required={true} disabled={inputs.handicapID !== "" ? true :false} />
                              <label className="form-check-label" htmlFor="male">Male</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input className="form-check-input" type="radio" id="female" name="sex" value='F' onChange={handleChange} checked={inputs.sex === "F"} required={true} disabled={inputs.handicapID !== "" ? true :false} />
                              <label className="form-check-label" htmlFor="female">Female</label>
                            </div>
                          </div> 
                        </div>
                      </div>
                      
                  </div>
               </div>
              <div className="mt-4 col-12 col-sm-12 col-lg-12">
                <div className="row">
                <div className="col-12 col-sm-6 order-1 pt-3">
                    <Link replace={true} to="/personal-lookup" state={{zipcode:zipsearch, aga:agadata, inputs:inputs}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                        BACK
                    </Link>
                   
                </div>
                <div className="col-12 col-sm-6 order-sm-1 order-lg-1 pt-3">
                    <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit" disabled={validate} >
                        CONTINUE
                    </button>
                </div>
                </div>
            </div>
            <div className="row text-center"><p className="pt-4">If you're having trouble, contact the <a href='mailto:gcsupport@usga.org' target="blank">USGA</a>.</p></div>
            </form> 
            </div>
        </div>
        </div>
    )
}